import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {connect, useSelector} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as events from '../../store/events'
import * as site from '../../store/site'
import * as user from '../../store/user'

import nav from '../../config/headerConfig'
import {isCurrentPageOnboardingStandalone} from '../Onboarding/standaloneUtils'

import {AccountCta} from './AccountCta'
import {GarmentCta} from './GarmentCta'
import HeaderLogo from './HeaderLogo'
import MobileMenuTrigger from './MobileMenuTrigger'
import Nav from './Nav'
import StandaloneOnboardingHeader from './StandaloneOnboardingHeader'

import '../../../scss/components/_header.scss'
import {isBuyPathActive} from '../../feature-flags'
import {totalNumberOfLooks} from '../../store/looks'
import styles from './Header.module.scss'

const Header = ({eventHasBeenCreated, isLoggedIn, minNavIsActive, email}) => {
  const numLooks = useSelector(totalNumberOfLooks)
  const renderLegacyNav = isLoggedIn && email.includes('@theblacktux.com')
  const renderGarmentBag = false

  const classes = classNames('c-header', 'js-header', {
    'c-header--has-event': eventHasBeenCreated,
    'c-header--minimal': minNavIsActive,
  })

  let navWithoutBuyNew = {...nav, items: nav.items.filter(({title}) => title !== 'Buy New')}
  navWithoutBuyNew = {
    ...navWithoutBuyNew,
    items: navWithoutBuyNew.items.map((item) => {
      if (item.title === 'Rental') {
        return {...item, title: 'Our Collection'}
      }
      return item
    }),
  }

  const showroomNav = {
    ...nav,
    items: nav.items.filter(({title}) => title === 'Showrooms'),
  }

  const renderCounter = () => {
    if (isLoggedIn && numLooks > 0) {
      return (
        <div className={styles.counterContainer}>
          <span className={styles.counter}>{numLooks}</span>
        </div>
      )
    }

    return null
  }

  return isCurrentPageOnboardingStandalone() ? (
    <StandaloneOnboardingHeader />
  ) : (
    <header className={classes}>
      <HeaderLogo />
      <MobileMenuTrigger />
      {renderLegacyNav ? (
        <Nav data={isBuyPathActive ? nav : navWithoutBuyNew} />
      ) : (
        <Nav data={showroomNav} />
      )}
      <div className={styles.rightNavCtas}>
        <AccountCta isLoggedIn={isLoggedIn} />
        {isLoggedIn && renderGarmentBag && (
          <div className={styles.garmentBagContainer}>
            <GarmentCta />
            {renderCounter()}
          </div>
        )}
      </div>
    </header>
  )
}

Header.propTypes = {
  eventHasBeenCreated: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  minNavIsActive: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
}

const mapStateToProps = createStructuredSelector({
  eventHasBeenCreated: events.currentEventIsValid,
  isLoggedIn: user.isAuthenticated,
  email: user.email,
  minNavIsActive: site.minNavIsActive,
})

export default connect(mapStateToProps)(Header)
